<div class="w-full min-h-screen bg-[#232323] text-white">
  <!-- Header -->
  <header class="px-8 md:px-16 pt-8 pb-6">
    <div class="flex items-start gap-4">
      <button mat-icon-button (click)="voltarAcademia()" 
              class="!bg-zinc-800 hover:!bg-zinc-700 !text-white -ml-2 mt-1"
              matTooltip="Voltar para a academia">
        <mat-icon svgIcon="heroicons_outline:arrow-left" class="icon-size-5"></mat-icon>
      </button>
      <div class="flex-1">
        <div class="flex items-center gap-3 mb-2">
          <span class="text-xs font-semibold uppercase tracking-wider text-[#E4811E] bg-[#E4811E]/10 px-3 py-1 rounded-full">
            Módulo
          </span>
          <span *ngIf="getAulasConcluidas() > 0" class="text-xs text-green-400 bg-green-500/10 px-3 py-1 rounded-full">
            {{ getAulasConcluidas() }}/{{ aulas.length }} concluídas
          </span>
        </div>
        <h1 class="text-3xl md:text-4xl font-extrabold text-white leading-tight">{{ aulas[0]?.moduloNome }}</h1>
        <p *ngIf="aulas[0]?.moduloDescricao" class="mt-2 text-white/60 text-base md:text-lg max-w-3xl">{{ aulas[0]?.moduloDescricao }}</p>
      </div>
    </div>
  </header>

  <!-- Barra de Progresso -->
  <div *ngIf="aulas.length > 0" class="px-8 md:px-16 pb-6">
    <div class="bg-zinc-800/50 rounded-xl p-4 border border-zinc-700">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-lg bg-[#E4811E]/10 flex items-center justify-center">
            <mat-icon svgIcon="heroicons_outline:chart-bar" class="text-[#E4811E] icon-size-5"></mat-icon>
          </div>
          <div>
            <p class="font-semibold text-white">Progresso do Módulo</p>
            <p class="text-xs text-white/50">{{ getAulasConcluidas() }} de {{ aulas.length }} aulas concluídas</p>
          </div>
        </div>
        <span class="text-2xl font-bold text-[#E4811E]">{{ getProgressoPercentual() }}%</span>
      </div>
      <div class="h-2 bg-zinc-700 rounded-full overflow-hidden">
        <div class="h-full bg-gradient-to-r from-[#E4811E] to-[#f59e0b] rounded-full transition-all duration-500"
             [style.width.%]="getProgressoPercentual()"></div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="carregando" class="px-8 md:px-16 pb-10">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      <div *ngFor="let _ of [0,1,2,3,4,5,6,7]" class="animate-pulse">
        <div class="aspect-video rounded-2xl bg-zinc-800"></div>
        <div class="mt-3 h-4 bg-zinc-800 rounded w-3/4"></div>
        <div class="mt-2 h-3 bg-zinc-800 rounded w-1/2"></div>
      </div>
    </div>
  </div>

  <!-- Grid de Aulas -->
  <div *ngIf="!carregando" class="px-8 md:px-16 pb-12">
    <div class="flex items-center justify-between mb-6">
      <h2 class="text-xl font-bold text-white">Todas as aulas</h2>
      <span class="text-sm text-white/50">{{ aulas.length }} aulas</span>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      <div *ngFor="let aula of aulas; let i = index" 
           class="group cursor-pointer"
           (click)="abrirAula(aula)">
        
        <!-- Card da Aula -->
        <div class="relative aspect-video rounded-2xl overflow-hidden bg-zinc-800 ring-1 ring-white/10 transition-all duration-300 group-hover:ring-[#E4811E]/50 group-hover:shadow-xl group-hover:shadow-[#E4811E]/10 group-hover:scale-[1.02]">
          
          <!-- Imagem de Capa -->
          <img *ngIf="aula.imagemUrl" 
               [src]="aula.imagemUrl" 
               [alt]="aula.titulo"
               class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
          
          <!-- Placeholder se não tiver imagem -->
          <div *ngIf="!aula.imagemUrl" 
               class="w-full h-full flex items-center justify-center bg-gradient-to-br from-zinc-700 to-zinc-800">
            <mat-icon svgIcon="heroicons_outline:play-circle" class="text-white/20 icon-size-16"></mat-icon>
          </div>

          <!-- Overlay Gradiente -->
          <div class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

          <!-- Badge: Número da Aula -->
          <div class="absolute top-3 right-3 bg-black/60 backdrop-blur-sm rounded-lg px-2.5 py-1 text-xs font-semibold text-white">
            Aula {{ aula.ordemAula }}
          </div>

          <!-- Badge: Status Concluída -->
          <div *ngIf="aula.concluida" 
               class="absolute top-3 left-3 flex items-center gap-1.5 bg-green-500/90 backdrop-blur-sm rounded-lg px-2.5 py-1 text-xs font-semibold text-white">
            <mat-icon svgIcon="heroicons_mini:check" class="icon-size-3.5"></mat-icon>
            Concluída
          </div>

          <!-- Info da Aula -->
          <div class="absolute inset-x-0 bottom-0 p-4">
            <p class="text-lg font-bold text-white leading-snug line-clamp-2 drop-shadow-lg"
               [matTooltip]="aula.titulo"
               matTooltipPosition="above">
              {{ aula.titulo }}
            </p>
            <p *ngIf="aula.duracao" class="text-sm text-white/60 mt-1 flex items-center gap-1.5">
              <mat-icon svgIcon="heroicons_outline:clock" class="icon-size-4"></mat-icon>
              {{ aula.duracao }}
            </p>
          </div>

          <!-- Overlay de Play no Hover -->
          <div class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div class="w-16 h-16 rounded-full bg-[#E4811E]/90 flex items-center justify-center shadow-xl transform scale-90 group-hover:scale-100 transition-transform duration-300">
              <mat-icon svgIcon="heroicons_solid:play" class="text-white icon-size-8 ml-1"></mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="aulas.length === 0" class="text-center py-16">
      <div class="w-20 h-20 rounded-full bg-zinc-800 flex items-center justify-center mx-auto mb-4">
        <mat-icon svgIcon="heroicons_outline:film" class="text-white/30 icon-size-10"></mat-icon>
      </div>
      <h3 class="text-xl font-semibold text-white mb-2">Nenhuma aula encontrada</h3>
      <p class="text-white/50">Este módulo ainda não possui aulas disponíveis.</p>
    </div>
  </div>
</div>